import { forEach, get, set } from 'lodash';
import urlParse from 'url-parse';

const isOverflow = (element) => {
  return element.clientWidth < element.scrollWidth;
};

const isPositionStickySupported = () => {
  if (window) {
    const el = document.createElement('div');

    el.style.cssText = 'position:sticky;position:-webkit-sticky;position:-ms-sticky';

    return el.style.position.indexOf('sticky') !== -1;
  }

  return false;
};

const generateStyles = (wrapper, styleList) => {
  let wrappedStyles = '';

  forEach(styleList, (element) => {
    wrappedStyles += wrapper + " " + element.selector + "{" + element.styles + "} ";
  });

  return wrappedStyles;
};

const checkIOSDevice = () => {
  return (typeof navigator === 'object') ? navigator.userAgent.match(/iPad|iPhone|iPod/i) : false;
};

/**
 * Override some link anchors onclick behavior
 * to make sure the page is scrolled to the right anchor position
 * (More context: there is a bug that the page is not scrolled to the right anchor position
 *  caused by the menu)
 */ 
const scrollToLinkAnchor = (href, e) => {
  const { 
    origin = '', 
    pathname: pathName = '', 
    hash = '' 
  } = urlParse(href);

  const currentPath = get(window, 'location.origin', '') +
    get(window, 'location.pathname', '');
  const linkPath = origin + pathName;

  const nodeId = hash.replace('#', '');

  if (linkPath === currentPath && hash) {
    e.preventDefault();
    const nodeDom = document.getElementById(nodeId);
    set(window, 'location.hash', hash);

    if (nodeDom) {
      window.scrollTo(0, nodeDom.offsetTop);
    }
  }
};

export {
  isOverflow,
  isPositionStickySupported,
  generateStyles,
  checkIOSDevice,
  scrollToLinkAnchor
};



// WEBPACK FOOTER //
// ./app/utils/DOMUtils.js